import { useEffect } from 'react';

import { initClarity } from '~app/clarity-init';

export const AppClarity = () => {
  useEffect(() => {
    if ('requestIdleCallback' in window) {
      (
        window as Window & {
          requestIdleCallback: (cb: IdleRequestCallback) => number;
        }
      ).requestIdleCallback(() => {
        initClarity();
      });
      return;
    }

    setTimeout(() => {
      initClarity();
    }, 0);
  }, []);

  return null;
};
